import i18next from 'i18next';

i18next.addResources('es', 'NewWorkspace', {
  subtitle: 'Ya puede comenzar a colaborar en su nuevo espacio de trabajo.',
  body: 'Si desea volver al espacio de trabajo anterior, contáctese con el administrador de dicho espacio para volver a ser invitado.'
});
